// Module
var code = "<div class=\"limitsHeader\"></div>\n<div class=\"timeSelector\"></div>\n<div data-type=\"horizontal\" data-role=\"controlgroup\">\n    <a id=\"timeSelectorDoneButton\" href=\"#\" data-role=\"button\" data-i18n=\"common::done.title\"></a>\n</div>";
// Exports
module.exports = code;